import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getJockeys, saveFilteredJockeys } from '../store/reducers/Stable/jockeys';
import { getSkins } from '../store/reducers/Stable/skins';
import { getHorses, saveFilteredHorses } from '../store/reducers/Stable/slice';
import { Routes } from '../constants/routes';
import { useDispatch, useSelector } from 'react-redux';
export const useStakeId = () => {
    const params = useParams();
    const address = useSelector((state) => state.wallet.activeWallet.address);
    return params.stakeId || address;
};
export const useHorses = () => {
    const dispatch = useDispatch();
    const stakeId = useStakeId();
    const horses = useSelector((state) => state.stable.horses);
    const pending = useSelector((state) => state.stable.pending);
    useEffect(() => {
        if (stakeId && !horses && !pending) {
            dispatch(getHorses({ walletId: stakeId }));
        }
    }, [stakeId, dispatch, horses, pending]);
    useEffect(() => {
        if (horses && !pending) {
            dispatch(saveFilteredHorses(horses));
        }
    }, [horses, pending]);
    return { horses, pending };
};
export const useJockeys = () => {
    const dispatch = useDispatch();
    const stakeId = useStakeId();
    const jockeys = useSelector((state) => state.jockeys.jockeys);
    const pending = useSelector((state) => state.jockeys.pending);
    useEffect(() => {
        if (stakeId && !jockeys && !pending) {
            dispatch(getJockeys({ walletId: stakeId }));
        }
    }, [dispatch, jockeys, pending, stakeId]);
    useEffect(() => {
        if (jockeys && !pending) {
            dispatch(saveFilteredJockeys(jockeys));
        }
    }, [jockeys, pending]);
    return { jockeys, pending };
};
export const useSkins = () => {
    const dispatch = useDispatch();
    const stakeId = useStakeId();
    const skins = useSelector((state) => state.skins.skins);
    const pending = useSelector((state) => state.skins.pending);
    useEffect(() => {
        if (stakeId && !skins && !pending) {
            dispatch(getSkins({ walletId: stakeId }));
        }
    }, [stakeId, dispatch, skins, pending]);
    return { skins, pending };
};
export const useStableRoutes = () => {
    const { stakeId } = useParams();
    const stableRoute = stakeId
        ? Routes.STABLES_STAKE_ID.replace(':stakeId', stakeId)
        : Routes.STABLES;
    const listRoute = stakeId
        ? Routes.STABLES_LIST_STAKE_ID.replace(':stakeId', stakeId)
        : Routes.STABLES_LIST;
    const horsesListRoute = stakeId
        ? Routes.STABLES_LIST_HORSES_STAKE_ID.replace(':stakeId', stakeId)
        : Routes.STABLES_LIST_HORSES;
    const jockeysListRoute = stakeId
        ? Routes.STABLES_LIST_JOCKEYS_STAKE_ID.replace(':stakeId', stakeId)
        : Routes.STABLES_LIST_JOCKEYS;
    const configuratorRoute = stakeId
        ? Routes.CONFIGURATOR_STAKE_ID.replace(':stakeId', stakeId)
        : Routes.CONFIGURATOR;
    const horseRoute = stakeId
        ? Routes.RACE_HORSE_STABLE_ID.replace(':stakeId', stakeId)
        : Routes.RACE_HORSE_STABLE_ID.replace('/:stakeId', '');
    const jockeyRoute = stakeId
        ? Routes.RACE_JOCKEY_STABLE_ID.replace(':stakeId', stakeId)
        : Routes.RACE_JOCKEY_STABLE_ID.replace('/:stakeId', '');
    return {
        stableRoute,
        listRoute,
        horsesListRoute,
        jockeysListRoute,
        configuratorRoute,
        horseRoute,
        jockeyRoute
    };
};
